import { DOCUMENT } from '@angular/common';
import { inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  defer,
  filter,
  fromEvent,
  map,
  merge,
  repeat,
  startWith,
  timer,
} from 'rxjs';

const MINUTE = 60 * 1000;

@Injectable({
  providedIn: 'root',
})
export class ClockService {
  private readonly document = inject(DOCUMENT);

  /**
   * The current time, updated on each minute boundary and when the tab
   * becomes visible again, as timers are throttled in background tabs.
   */
  readonly now: Signal<Date> = toSignal(
    merge(
      defer(() => timer(MINUTE - (Date.now() % MINUTE))).pipe(repeat()),
      fromEvent(this.document, 'visibilitychange').pipe(
        filter(() => this.document.visibilityState === 'visible')
      )
    ).pipe(
      startWith(0),
      map(() => new Date())
    ),
    { requireSync: true }
  );
}
